<template>
  <v-input
    :label="label"
    :rules="rules"
    :error-messages="validaCampo"
    v-model="valorInterno"
    class="InputMoney v-text-field"
    :class="{focused, dirty, alignRight}"
    :required="required"
    :disabled="disabled"
    :hint="hint"
    :persistent-hint="persistentHint"
    :dense="dense"
    :single-line="singleLine"
    :hide-details="hideDetails">
    <money
      v-model="valorInterno"
      v-bind="money"
      :id="id"
      @input="valorDinheiroAlterado"
      :disabled="disabled">
    </money>
  </v-input>
</template>
<script>
import { Money } from 'v-money';

export default {
  name: 'InputMoney',
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: String,
    id: {
      type: String,
      default: () => `InputMoney-${Date.now().toString()}`,
    },
    rules: {
      type: Array,
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    alignRight: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    singleLine: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Money,
  },
  watch: {
    value: {
      immediate: true,
      handler(alterado) {
        this.valorInterno = alterado;
      },
    },
  },
  computed: {
    hasErrors() {
      if (!this.required) {
        return false;
      }

      const val = this.valorInterno,
        hasErrors = (val === null || val === this.valorVazioDinheiro);
      return hasErrors;
    },
    validaCampo() {
      if (this.hasErrors) {
        return this.$t('message.campo_obrigatorio');
      }
      return null;
    },
  },
  data() {
    return {
      dirty: false,
      focused: false,
      valorInterno: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      valorVazioDinheiro: 0,
    };
  },
  methods: {
    valorDinheiroAlterado(valor) {
      if (valor === this.value) return;
      this.$emit('InputMoney_valorAlterado', valor);
      this.$emit('input', valor);
    },
    refresh() {
      this.$forceUpdate();
    },
  },
  mounted() {
    const input = document.getElementById(this.id);

    input.addEventListener('focus', () => {
      this.focused = true;
    }, false);

    input.addEventListener('keyup', () => {
      this.dirty = true;
    }, false);

    input.addEventListener('blur', () => {
      this.focused = false;
      this.dirty = true;
      this.$emit('blur');
    }, false);
  },
};
</script>

<style>
.InputMoney.v-input--is-disabled .v-input__slot:before {
  border-image: repeating-linear-gradient(90deg,rgba(0,0,0,.38) 0,rgba(0,0,0,.38) 2px,transparent 0,transparent 4px) 1 repeat;
}
.InputMoney:not(.dirty).error--text .v-input__slot:before {
  border-color: rgba(0,0,0,.42);
}
.InputMoney:not(.dirty).error--text input {
  caret-color: rgba(0,0,0,.42);
}
.InputMoney.dirty.error--text .v-input__slot:before {
  border-color: #b71c1c;
}
.InputMoney.dirty.error--text input {
  caret-color: #b71c1c;
}
.InputMoney:not(.focused){
  color: rgba(0,0,0,.42) !important;
}
.InputMoney .v-input__slot {
  transition: background .3s cubic-bezier(.25,.8,.5,1);
}
.InputMoney .v-input__slot:before {
  border-color: currentColor;
  border-style: solid;
  border-width: thin 0 0;
}
.InputMoney.error--text:not(.dirty) .v-input__slot:after {
  border-color: rgba(0,0,0,.42) !important;
}
.InputMoney .v-input__slot:after {
  border-color: currentColor;
}
.InputMoney .v-input__slot:after {
  border-style: solid;
  border-width: thin 0;
  transform: scaleX(0);
}
.InputMoney .v-input__slot:before,
.InputMoney .v-input__slot:after {
  bottom: -1px;
  content: "";
  left: 0;
  position: absolute;
  transition: .3s cubic-bezier(.25,.8,.5,1);
  width: 100%;
}
.InputMoney.focused .v-input__slot:after {
  transform: scaleX(1);
}
.InputMoney:not(.dirty) .v-input__slot .v-label {
  color: rgba(0,0,0,.54) !important;
}
.InputMoney .v-input__slot .v-label {
  position: absolute !important;
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  top: 6px;
  transform-origin: top left;
  white-space: nowrap;
}
.InputMoney .v-input__slot .v-label {
  max-width: 100%;
  transform: translateY(-18px) scale(.75);
}
.InputMoney .v-input__slot .v-label:not(.error--text) {
  color: currentColor !important;
}
.InputMoney.v-input input:invalid,
.InputMoney.v-input input:required {
  box-shadow: none;
}
.InputMoney.v-input input {
  flex: 1 1 auto;
  line-height: 20px;
  padding: 8px 0;
  max-width: 100%;
  width: 100%;
}
.InputMoney.alignRight.v-input input {
  text-align: right;
}
</style>
